import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import { Paper } from '@mui/material';
import store from './store';
import { useTranslation } from 'react-i18next';
import OrganizationSettingListView from 'features/Organisation_setting/Organization_settingListView';
import UserAccountListView from 'features/user_account/user_accountListView';
import DepartmentListView from 'features/Department/DepartmentListView';


const OrganizationMtmTabs = observer(() => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const translate = t;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box component={Paper} elevation={5}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab data-testid={"OrganizationSetting_tab_title"} label={translate("label:organization_settingListView.entityTitle")} {...a11yProps(0)} />
          <Tab data-testid={"UserAccount_tab_title"} label={translate("label:user_accountListView.entityTitle")} {...a11yProps(1)} />
          <Tab data-testid={"Department_tab_title"} label="Отделы" {...a11yProps(2)} />
        </Tabs>
      </Box>
      
      <CustomTabPanel value={value} index={0}>
        <OrganizationSettingListView idMain={store.id} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UserAccountListView idMain={store.id} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <DepartmentListView idMain={store.id} />
      </CustomTabPanel>
    </Box>
  );

})


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default OrganizationMtmTabs